module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "nav"
  }, [_c('div', _vm._l((_vm.bible), function(item, i) {
    return _c('a', {
      key: i,
      class: {
        on: _vm.selected === i
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSelected(i)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), (_vm.selected === 2) ? _c('div', {
    staticClass: "details"
  }, _vm._l((_vm.contents), function(d, i) {
    return _c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onGo(d)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(d.name))])])
  }), 0) : [_vm._l((_vm.contents), function(item, index) {
    return [_c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, _vm._l((item.child), function(d, i) {
      return _c('a', {
        key: i,
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.onGo(d)
          }
        }
      }, [_c('div', [_vm._v(_vm._s(d.letter))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(d.name))])])
    }), 0)]
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e9abac2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/bible/index.vue
// module id = 313
// module chunks = 0